export const tShirtSizes = [
    { "id": "1", "title": "S", "isActive": 1 },
    { "id": "2", "title": "M", "isActive": 1 },
    { "id": "3", "title": "L", "isActive": 1 },
    { "id": "4", "title": "XL", "isActive": 1 },
    { "id": "5", "title": "2XL", "isActive": 1 },
    { "id": "6", "title": "3XL", "isActive": 1 }
]